import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Pagination } from '../charitra/charitra.service';
import { Constants } from '../app.constants';

@Injectable({
  providedIn: 'root'
})
export class GallaryService {
  pageSize = 12;
  constructor(private httpClient: HttpClient) { }


  get(input: InputParameters): Observable<GalleryPagination> {
    return this.httpClient.post<GalleryPagination>(Constants.gallery, input);
  }
}

export class InputParameters {
  constructor() { }
  pageSize = 12;
  pageNumber = 1;
  search = "";
}

export class GalleryPagination {
  constructor(  ) {  }
  pageNumber: number =0;
  pageSize: number = 0;
  content: GalleryVM[] = [];
  remainingCount: number = 0;
}

export class GalleryVM{
  constructor(){}
  id:number = 0;
  thm_path:string = "";
  path:string = "";
  city:string = "";
  sthan:string = "";
  sthanEnglish:string = "";
}